module.exports = __webpack_public_path__ + "c8e24be92971bce29069032a71c02ae3.pdf";